var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "users_list mt-3" }, [
    _c(
      "ul",
      { staticClass: "user_list_to_insert" },
      _vm._l(_vm.u_list, function (item, index) {
        return _c(
          "li",
          {
            staticClass: "border cursor-pointer shadow-1 mt-1 mb-2",
            class: _vm.user_class(item),
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.set_active(item, index)
              },
            },
          },
          [
            _c("user_block", {
              key: item.id,
              attrs: {
                show_vacation: true,
                user: item,
                padding_class: "pt-2 pl-2 pb-1",
              },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }